/**
 * Hook for syncing thread messages when threadId changes
 * 
 * AI SDK v6 IMPORTANT: This hook is now DEPRECATED and should be removed.
 * 
 * The useChat hook with the `id` prop handles ALL message persistence automatically:
 * 1. Initial messages are loaded via `initialMessages` prop (server-side)
 * 2. New messages are saved via `onFinish` callback in toUIMessageStreamResponse()
 * 3. The `id` prop ensures messages are associated with the correct thread
 * 
 * Manually calling setMessages() breaks the AI SDK v6 streaming protocol and causes:
 * - Duplicate messages being sent to the backend
 * - Streaming state corruption
 * - Empty responses from the LLM
 * 
 * See: https://sdk.vercel.ai/docs/ai-sdk-ui/chatbot-message-persistence
 */
import { Message } from 'ai';

export function useChatThreadSync(
  currentThreadId: string | undefined,
  chatbotId: string | undefined,
  setMessages: (messages: Message[] | ((messages: Message[]) => Message[])) => void,
  status: string,
  error: Error | null
) {
  // AI SDK v6 handles ALL message persistence automatically
  // DO NOT manually fetch or override messages - it breaks streaming
  // This hook is kept for backwards compatibility but does nothing
}

